import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=6875f700&scoped=true"
import script from "./Endorsement.vue?vue&type=script&lang=js"
export * from "./Endorsement.vue?vue&type=script&lang=js"
import style0 from "./Endorsement.vue?vue&type=style&index=0&id=6875f700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875f700",
  null
  
)

export default component.exports